import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/App";
import { Loader2 } from "lucide-react";

/**
 * ConnectRefreshPage
 * Stripe hits this URL when an Account Link expires or the seller
 * refreshes the onboarding page. We immediately mint a fresh link and
 * bounce the seller back into onboarding — no visible dead-end.
 */
export default function ConnectRefreshPage() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.post(
          `${API}/connect/onboarding-link`,
          { origin_url: window.location.origin },
          { withCredentials: true }
        );
        if (cancelled) return;
        window.location.href = r.data.onboarding_url;
      } catch (e) {
        if (cancelled) return;
        setError(e.response?.data?.detail || "Couldn't refresh the setup link");
        toast.error("Couldn't refresh the setup link — heading back to Dashboard");
        setTimeout(() => navigate("/dashboard", { replace: true }), 2000);
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-tbc-cream" data-testid="connect-refresh-page">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-tbc-gold animate-spin mx-auto" />
        <p className="mt-4 text-tbc-navy font-body">
          {error || "Getting you back to Stripe…"}
        </p>
      </div>
    </div>
  );
}
